import { render, staticRenderFns } from "./AccountingPointPlanForm.vue?vue&type=template&id=e2b881ee&scoped=true&"
import script from "./AccountingPointPlanForm.vue?vue&type=script&lang=ts&"
export * from "./AccountingPointPlanForm.vue?vue&type=script&lang=ts&"
import style0 from "./AccountingPointPlanForm.vue?vue&type=style&index=0&id=e2b881ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b881ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VForm,VIcon,VTextField})
